import React from 'react';
import {useParams} from "react-router-dom";
import ViewTemplate from "../../components/ViewTemplate/ViewTemplate";

function Template() {
	const {templateId} = useParams();
	if(!templateId) return <></>;
	return (
		<div className="w-full relative pt-16">
			<ViewTemplate id={templateId} />
		</div>
	);
}

export default Template;
